__turbopack_context__.v({
  "badge": "index-module-scss-module__KHlmbq__badge",
  "button": "index-module-scss-module__KHlmbq__button",
  "face2faceBox": "index-module-scss-module__KHlmbq__face2faceBox",
  "icons": "index-module-scss-module__KHlmbq__icons",
  "imageContainer": "index-module-scss-module__KHlmbq__imageContainer",
  "list": "index-module-scss-module__KHlmbq__list",
  "listItem": "index-module-scss-module__KHlmbq__listItem",
  "modal": "index-module-scss-module__KHlmbq__modal",
  "paymentMethod": "index-module-scss-module__KHlmbq__paymentMethod",
  "thankyou": "index-module-scss-module__KHlmbq__thankyou",
  "tick": "index-module-scss-module__KHlmbq__tick",
});
